import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import formService from "./formService";

const initialState = {
    all_forms: [],
    single_form: null,
    unpaginated_forms: null,
    isLoading: false,
    createSuccess: false,
    isSuccess: false,
    updateSuccess: false,
};
  
  const formSlice = createSlice({
    initialState,
    name: "form",
    reducers: {
        resetForm: (state) => initialState,
        resetFormStatus: (state) => {
            state.createSuccess = false;
            state.isLoading = false;
            state.isSuccess = false;
            state.updateSuccess = false;

        },
        resetSingleForm: (state) =>{
          state.single_form = null;
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(createCustormForm.pending, (state) => {
            state.isLoading = true;
            flash("info", "Creating Custom Form");
          })
          .addCase(createCustormForm.fulfilled, (state, {payload}) => {
            state.isLoading = false;
            if (!payload.errors) {
                state.createSuccess = true
                flash("success", "Custom Form Created Successfully")
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(createCustormForm.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
          .addCase(updateCustormForm.pending, (state) => {
            state.isLoading = true;
            flash("info", "Updating Custom Form");
          })
          .addCase(updateCustormForm.fulfilled, (state, {payload}) => {
            state.isLoading = false;
            if (!payload.errors) {
                state.updateSuccess = true
                flash("success", "Custom Form Updated Successfully")
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(updateCustormForm.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
          .addCase(getAllForms.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getAllForms.fulfilled, (state, {payload}) => {
            state.isLoading = false;
            if (!payload.errors) {
                state.isSuccess = true
                state.all_forms = payload.AllForm
                state.unpaginated_forms = payload.unpaginatedgetAllForm
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(getAllForms.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
          .addCase(getSingleForm.pending, (state) => {
            state.isLoading = true;
            state.isSuccess = false
          })
          .addCase(getSingleForm.fulfilled, (state, {payload}) => {
            state.isLoading = false;
            if (!payload.errors) {
                state.single_form = payload.view_Form
                state.isSuccess = true;
            } else if (typeof payload.errors == "string") {
              flash("error", payload.errors);
            } else {
              let key = Object.keys(payload.errors)[0];
              let message = payload.errors[key][0];
              flash("error", message);
            }
          })
          .addCase(getSingleForm.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
          })
    }
})
export const createCustormForm = createAsyncThunk(
    "/form/createCustormForm",
    async (data, thunkAPI) => {
        try {
            return await formService.createCustormForm(data);
        } catch (error) {
        const message =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateCustormForm = createAsyncThunk(
    "/form/updateCustormForm",
    async (data, thunkAPI) => {
        try {
            return await formService.updateSingleForm(data);
        } catch (error) {
        const message =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        return thunkAPI.rejectWithValue(message);
        }
    }
);

export const getAllForms = createAsyncThunk(
    "/form/getAll",
    async (data, thunkAPI) => {
        try {
            return await formService.getAllForms(data);
        } catch (error) {
        const message =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        return thunkAPI.rejectWithValue(message);
        }
    }
);
export const getSingleForm = createAsyncThunk(
    "/form/getSingle",
    async (pageNum, thunkAPI) => {
        try {
            return await formService.getSingleForm(pageNum);
        } catch (error) {
        const message =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
        return thunkAPI.rejectWithValue(message);
        }
    }
);

export const { resetForm, resetFormStatus, resetSingleForm} = formSlice.actions;
export default formSlice.reducer;